export const SITE_ENVIRONMENTS = {
  AUSTRALIA: 'australia',
  INDONESIA: 'indonesia'
}
